//https://server2.purnaacademic.in:8443/dairy-warna/


// export const BaseIp = "http://192.168.195.102:8083"

// online Base Ip
export const BaseIp = "https://server2.purnaacademic.in:8443"


export const BaseUrl = BaseIp + "/dairy-warna"

export const BaseUrlAuth = BaseUrl + "/auth"

export const pdfPathAPIURL = BaseIp + "/output/"



